import Take3D, { getTake3DSequence } from "../../models/Take3D";

export type TimelineIssueMap = Record<string, unknown[] | undefined>;

export interface TakeIssueSummary {
  warningCount: number;
  errorCount: number;
  hasWarnings: boolean;
  hasErrors: boolean;
}

export function getTakeValidationEntityIds(take: Take3D) {
  const sequence = getTake3DSequence(take);

  return [
    take.id,
    take.mainCamera?.id,
    take.transition?.id,
    sequence?.id,
    ...take.interactions
      .filter((interaction) => interaction.disabled !== true)
      .map((interaction) => interaction.id),
  ].filter((id): id is string => Boolean(id));
}

export function getTakeIssueSummary(
  take: Take3D,
  warnings: TimelineIssueMap,
  errors: TimelineIssueMap
): TakeIssueSummary {
  const ids = getTakeValidationEntityIds(take);
  const warningCount = ids.reduce(
    (total, id) => total + (warnings[id]?.length ?? 0),
    0
  );
  const errorCount = ids.reduce(
    (total, id) => total + (errors[id]?.length ?? 0),
    0
  );

  return {
    warningCount,
    errorCount,
    hasWarnings: warningCount > 0,
    hasErrors: errorCount > 0,
  };
}
